import "./StatsCard.css";

function StatsCard({
  title,
  value,
  icon,
  color = "#A0001C",
  growth,
  subtitle,
}) {
  return (
    <div className="stats-card">

      <div
        className="stats-icon"
        style={{ background: color }}
      >
        {icon}
      </div>

      <div className="stats-content">

        <h4>{title}</h4>

        <h2>{value}</h2>

        {growth && (
          <div className="stats-footer">

            <span className="stats-growth">
              {growth}
            </span>

            {subtitle && (
              <small>{subtitle}</small>
            )}

          </div>
        )}

      </div>

    </div>
  );
}

export default StatsCard;